var render, staticRenderFns
import script from "./OrbatChart.vue?vue&type=script&lang=js"
export * from "./OrbatChart.vue?vue&type=script&lang=js"
import style0 from "./OrbatChart.vue?vue&type=style&index=0&id=4c091065&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports